module.exports = __webpack_public_path__ + "img/landing-screen-1.76b223b7.jpg";